import { PERMISSIONS } from './usersPermissions/usersPermissionsCultivares';

export const isSysAdmin = (roles: string[]): boolean => {
    const isRole = roles.filter(role => role === PERMISSIONS.SysAdmin);

    return isRole.length ? true : false;
}